import { MatSnackBar } from '@angular/material';
import { UserService } from '@user/user.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Subscription, from } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { IWorkbook, IErrorResponse, IUser, IWorkbooklog } from '@interfaces';
import { WorkbookService } from '@base/workbook/workbook.service';
import { ExceptionService } from '@base/exceptions.service';
import { EMPTY, getNumber, ROLES, getReferencedValue } from '@utils';
import { AppService } from '@base/app.service';
import { TableauService } from '@base/tableau/tableau.service';
import { map, mergeMap } from 'rxjs/operators';
import { AngularFireStorage } from '@angular/fire/storage';
import { environment } from '@environments/environment';
import { OpenWorkbookAs } from '@utils';

const BUCKET = environment.buckets;

interface IView {
  id: number;
  name: string;
  content_url: string;
  created_at: string;
  updated_at: string;
  tags: object;
  tableau_id: string;
  thumbnail: string;
}

@Component({
  templateUrl: './tableau-views.component.html',
  styleUrls: ['./tableau-views.component.sass']
})
export class TableauViewsComponent implements OnInit, OnDestroy {
  private subscriptions: Subscription[];
  private _workbook: IWorkbook = EMPTY;
  private _user: IUser = EMPTY;
  workbookId = EMPTY;
  workbook: IWorkbook;

  views: [];
  user: IUser;
  generatingUrl: boolean;
  workbooks: IWorkbook[];
  workbookFallbackImage = '/assets/splash-page-dashboard.png';
  gettingViews: boolean;

  constructor(
    private router: Router,
    private workbookService: WorkbookService,
    private userService: UserService,
    private exceptionService: ExceptionService,
    private mainService: AppService,
    private route: ActivatedRoute,
    private snackBar: MatSnackBar,
    private tableauService: TableauService,
    private fireStorage: AngularFireStorage
  ) {
    this.generatingUrl = false;
    this.gettingViews = true;
    this.user = EMPTY;
    this.workbook = EMPTY;
    this.subscriptions = [];
    this.workbooks = [];
    this.views = [];
    this.workbookId = this.route.snapshot.paramMap.get('id');
    this.workbookId = getNumber(this.workbookId);

    if (this.workbookId > 0) {
      const uSubscription = this.mainService.getCurrentUser().subscribe(
        (u: IUser) => {
          if (u.role['code'] === ROLES.CUSTOMER) {
            this.user = u;
          } else {
            this.router.navigate(['/home']);
          }
        },
        (e: HttpErrorResponse) => { const error: IErrorResponse = this.exceptionService.errorHandling(e); }
      );

      const uwSubscription = this.userService.observeUserWorkbooks().subscribe(
        (uw: IWorkbook[]) => {
          this.workbooks = uw;
          this.setActiveWorkbook();
        },
        (e: HttpErrorResponse) => { const err: IErrorResponse = this.exceptionService.errorHandling(e); }
      );

      const obs2 = this.workbookService.observeWorkbookSelected().subscribe(
        (wb: IWorkbook) => this._workbook = wb,
      );

      const obs3 = this.mainService.getCurrentUser().subscribe(
        (u: IUser) => this._user = u,
      );

      const wSubscription = this.workbookService.observeWorkbookSelected().subscribe(
        (w: IWorkbook) => {
          this.workbook = w;
          if (w !== EMPTY) {
            this.workbook = w;
            this.getViews(this.workbook.id);
          } else {
            // ESTA RECARGANDO LA PAGINA
            console.log('ESTA RECARGANDO LA PAGINA');
            this.setActiveWorkbook();
          }
        },
        (e: HttpErrorResponse) => { const error: IErrorResponse = this.exceptionService.errorHandling(e); }
      );

      this.subscriptions = [...this.subscriptions,
        wSubscription, uSubscription, uwSubscription, obs2, obs3,
      ];
    } else {
      this.router.navigate(['/home/panels/tableau/']);
    }
  }

  ngOnInit() {
    this.tableauService.setNavBackButtonStatus(true);
    this.tableauService.setDisplayTagsStatus(false);
  }

  ngOnDestroy() {
    this.subscriptions.map((s: Subscription) => s.unsubscribe());
    this.tableauService.setNavBackButtonStatus(false);
  }

  private setActiveWorkbook() {
    const IS_UNDEFINED = (typeof this.workbooks === 'undefined');

    if (!IS_UNDEFINED && this.workbook !== EMPTY) {
      const wbId = getReferencedValue(this.workbook, 'id');
      this.getViews(wbId);
      // const wb = this.workbooks.filter((w: IWorkbook) => w.id === (this.workbookId));
      // if (wb.length ) {
      //   this.workbook = wb[0];
      //   this.getViews(this.workbook);
      //   console.log('TableauViewsComponent', this.workbook.name);
      //   // this.workbookService.setWorkbook(wb[0]);
      // } else {
      //   this.router.navigate(['/home/panels/tableau/']);
      // }
    }
  }

  private extractThumbName(strUrl: string): string {
    const auxStrUrl = (' ' + strUrl).slice(1);
    const split1 = auxStrUrl.split('?');
    const token = split1[1];
    const split2 = split1[0].split('%2F');
    const thumbnailName = split2[3];
    return thumbnailName;
  }

  private getViews(wbId: number) {
    this.gettingViews = true;

    if (wbId !== EMPTY) {
      this.workbookService.getViews(wbId)
        .pipe(map((uWbs: []) => {
          uWbs.map((item: object) => {
            let thumbnailName = '';
            if (item['thumbnail'] !== EMPTY) {
              const urlPrefix = String(item['thumbnail']).substr(0, 5);
              thumbnailName = item['thumbnail'];

              if (urlPrefix === 'https') {
                thumbnailName = this.extractThumbName(String(item['thumbnail']));
              }
            }
            item['thumbnail'] = (item['thumbnail'] === EMPTY) ? EMPTY : thumbnailName;
          });
          return uWbs;
        }))
        .subscribe(
          (v: []) => {
            this.getPreviewImages(v);
            this.views = v;
          },
          (e: HttpErrorResponse) => {
            console.log(e.message);
            this.gettingViews = false;
          }
        );
    } else {
      this.gettingViews = false;
    }
  }

  private getPreviewImages(viewList: []) {
    const auxViewList = (typeof viewList !== 'undefined') ? viewList : [];

    let thumbnails = [];
    auxViewList.map(v => {
      // if (wb['thumbnail'] !== EMPTY) {
        thumbnails = [...thumbnails, v['thumbnail']];
      // }
    });

    from(thumbnails)
    .pipe(mergeMap((r) => {
      const uri = `${BUCKET.viewImages}${r}`;
      return this.fireStorage.ref(uri).getDownloadURL();
    }), )
    .subscribe(
      (res: object) => {
        const thumbnailName = this.extractThumbName(String(res));
        const objIndex = auxViewList.findIndex(w => w.thumbnail === thumbnailName);
        auxViewList[objIndex].thumbnail = res;
        this.workbooks = auxViewList;
      },
      (err: HttpErrorResponse) => {
        console.log(err.message);
        this.gettingViews = false;
      },
      () => this.gettingViews = false
    );
  }

  openWorkbook(v: IView) {
    if (this.user !== EMPTY) {
      this.generatingUrl = true;
      const arrayParams = v.content_url.split('/');
      const viewName = arrayParams.pop();
      this.workbookService.setStatusProcessingData(true);

      const ticket = this.userService.getTableauParams(this.user).subscribe(
        t => {
          this.workbookService.setStatusProcessingData(false);
          this.generatingUrl = false;

          if (parseInt(t['ticket'], 10) !== -1) {
            let targetUrl = `${t['host']}/trusted/${t['ticket']}/views/${this.workbook['content_url']}/${viewName}`;

            if (this.workbook.open_as === OpenWorkbookAs.Report) {
              targetUrl += `?:embed=yes&:toolbar=top&:showShareOptions=false&:scrolling=no`;
              this.workbookService.setFinalUrl(targetUrl);
              this.router.navigate([`/home/panels/tableau/${this.workbookId}/views/${viewName}`]);
            } else if (this.workbook.open_as === OpenWorkbookAs.Image) {
              targetUrl += `?format=png`;
              window.open(targetUrl, '_blank');
            }
          } else if (t['ticket'] !== -1) {
            this.openSnackBar('El reporte no esta disponible!', 'info');
          }
        },
        (err: HttpErrorResponse) => {
          this.workbookService.setStatusProcessingData(false);
          const error: IErrorResponse = this.exceptionService.errorHandling(err);
        }
      );
    }
  }

  private openSnackBar(message: string, action: string): void {
    this.snackBar.open(message, action, {
      verticalPosition: 'top',
      horizontalPosition: 'right',
      duration: 4000,
    });
  }
}
